import { render } from "./Trending.vue?vue&type=template&id=0ede2db2&scoped=true"
import script from "./Trending.vue?vue&type=script&lang=js"
export * from "./Trending.vue?vue&type=script&lang=js"

import "./Trending.vue?vue&type=style&index=0&id=0ede2db2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ede2db2"]])

export default __exports__